module.exports = __webpack_public_path__ + "static/media/light-b-2.5484939a.png";